export const APP_RENDERING_START = 'APP_RENDERING_START';
export const APP_RENDERING_DONE = 'APP_RENDERING_DONE';
export const APP_RENDERING_FAILED = 'APP_RENDERING_FAILED';
export const PDF_VIEWER_OPEN = 'PDF_VIEWER_OPEN';
export const PDF_VIEWER_CLOSE = 'PDF_VIEWER_CLOSE';
export const PDF_VIEWER_READY = 'PDF_VIEWER_READY';
export const PREVIEW_SELECTION_END = 'PREVIEW_SELECTION_END';
export const PREVIEW_PAGE_CLICK = 'PREVIEW_PAGE_CLICK';
